const state = {
  toast: {
    show: false,
    message: '',
    type: 'error'
  },
  showUpgradeModal: false
};

const mutations = {
  SHOW_TOAST(state, { message, type = 'error' }) {
    state.toast = { show: true, message, type };
  },
  HIDE_TOAST(state) {
    state.toast.show = false;
  },
  SET_SHOW_UPGRADE_MODAL(state, val) {
    state.showUpgradeModal = val;
  }
};

const actions = {
  showToast({ commit }, payload) {
    commit('SHOW_TOAST', payload);
    setTimeout(() => {
      commit('HIDE_TOAST');
    }, 5000);
  },
  openUpgradeModal({ commit }) {
    commit('SET_SHOW_UPGRADE_MODAL', true);
  },
  closeUpgradeModal({ commit }) {
    commit('SET_SHOW_UPGRADE_MODAL', false);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};

